import React, { useState } from 'react';
import { ArrowRight, ArrowLeft, CheckCircle2 } from 'lucide-react';

const QuoteBuilder = () => {
  const [step, setStep] = useState(1);
  const [selectedServices, setSelectedServices] = useState({
    website: null,
    leadGen: null,
    automation: null,
    addons: []
  });
  const [showQuote, setShowQuote] = useState(false);

  const websiteOptions = [
    { name: 'Not Required', price: 0 },
    { name: 'Basic Website', price: 300 },
    { name: 'Customized Website', price: '350–500' },
    { name: 'Business Website', price: 1000 },
    { name: 'Growth Website', price: 2500 },
    { name: 'Custom / eCommerce Website', price: '5,000+ (Quote on request)' }
  ];

  const leadGenOptions = [
    { name: 'Not Required', price: 0 },
    { name: 'Lead Starter', price: '500/month' },
    { name: 'Lead Growth', price: '1,500/month' },
    { name: 'Lead Scale', price: '3,000/month' }
  ];

  const automationOptions = [
    { name: 'Not Required', price: 0 },
    { name: 'AI Starter', price: '200/month + $500 setup' },
    { name: 'AI Growth', price: '450/month + $800 setup' },
    { name: 'AI Scale', price: 'Custom (Quote on request)' }
  ];

  const addonOptions = [
    { name: 'Extra website page', price: '$50–$75 per page' },
    { name: 'Extra social post', price: '$25 each' },
    { name: 'Extra reel', price: '$75 each' },
    { name: 'AI Caller setup', price: '$500 + per-call billing' },
    { name: 'Ad management', price: 'Ad spend billed separately' }
  ];

  const handleNext = () => {
    if (step < 4) setStep(step + 1);
    else setShowQuote(true);
  };

  const handlePrevious = () => {
    if (step > 1) setStep(step - 1);
  };

  const toggleAddon = (addon) => {
    if (selectedServices.addons.includes(addon)) {
      setSelectedServices({
        ...selectedServices,
        addons: selectedServices.addons.filter(a => a !== addon)
      });
    } else {
      setSelectedServices({
        ...selectedServices,
        addons: [...selectedServices.addons, addon]
      });
    }
  };

  if (showQuote) {
    return (
      <div
        className="max-w-4xl mx-auto p-8 rounded-lg fade-in"
        style={{
          background: 'rgba(0, 255, 209, 0.05)',
          border: '1px solid var(--border-subtle)'
        }}
      >
        <h3 className="display-medium mb-6 text-center" style={{ color: 'var(--text-primary)' }}>
          Your Custom Quote
        </h3>
        <p className="body-large mb-8 text-center" style={{ color: 'var(--text-secondary)' }}>
          Here's what we can build for you
        </p>

        <div className="space-y-4 mb-8">
          {selectedServices.website && selectedServices.website.name !== 'Not Required' && (
            <div className="flex justify-between items-center p-4 rounded" style={{ background: 'rgba(255, 255, 255, 0.03)' }}>
              <div>
                <div className="heading-3" style={{ color: 'var(--text-primary)' }}>{selectedServices.website.name}</div>
                <div className="body-small" style={{ color: 'var(--text-muted)' }}>Website Development</div>
              </div>
              <div className="heading-2" style={{ color: 'var(--brand-primary)' }}>${selectedServices.website.price}</div>
            </div>
          )}
          {selectedServices.leadGen && selectedServices.leadGen.name !== 'Not Required' && (
            <div className="flex justify-between items-center p-4 rounded" style={{ background: 'rgba(255, 255, 255, 0.03)' }}>
              <div>
                <div className="heading-3" style={{ color: 'var(--text-primary)' }}>{selectedServices.leadGen.name}</div>
                <div className="body-small" style={{ color: 'var(--text-muted)' }}>Lead Generation</div>
              </div>
              <div className="heading-2" style={{ color: 'var(--brand-primary)' }}>{selectedServices.leadGen.price}</div>
            </div>
          )}
          {selectedServices.automation && selectedServices.automation.name !== 'Not Required' && (
            <div className="flex justify-between items-center p-4 rounded" style={{ background: 'rgba(255, 255, 255, 0.03)' }}>
              <div>
                <div className="heading-3" style={{ color: 'var(--text-primary)' }}>{selectedServices.automation.name}</div>
                <div className="body-small" style={{ color: 'var(--text-muted)' }}>AI Automation</div>
              </div>
              <div className="heading-2" style={{ color: 'var(--brand-primary)' }}>{selectedServices.automation.price}</div>
            </div>
          )}
          {selectedServices.addons.map((addon, idx) => (
            <div key={idx} className="flex justify-between items-center p-4 rounded" style={{ background: 'rgba(255, 255, 255, 0.03)' }}>
              <div>
                <div className="heading-3" style={{ color: 'var(--text-primary)' }}>{addon.name}</div>
                <div className="body-small" style={{ color: 'var(--text-muted)' }}>Add-ons</div>
              </div>
              <div className="heading-2" style={{ color: 'var(--brand-primary)' }}>{addon.price}</div>
            </div>
          ))}
        </div>

        <div className="text-center space-y-4">
          <div className="display-medium" style={{ color: 'var(--brand-primary)' }}>Let's Discuss Your Project</div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://calendly.com/americanprimeforyou"
              target="_blank"
              rel="noopener noreferrer"
              className="button-text dark-button-animate inline-flex items-center justify-center space-x-2"
              style={{
                background: 'var(--brand-primary)',
                color: '#000000',
                padding: '14px 32px',
                borderRadius: '0px',
                textDecoration: 'none'
              }}
            >
              <span>Book a Call to Finalize Quote</span>
              <ArrowRight size={20} />
            </a>
            <button
              onClick={() => { setShowQuote(false); setStep(1); }}
              className="button-text dark-button-animate"
              style={{
                background: 'rgba(255, 255, 255, 0.1)',
                color: '#FFFFFF',
                padding: '14px 32px',
                borderRadius: '0px',
                border: 'none',
                cursor: 'pointer'
              }}
            >
              Start New Quote
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="max-w-4xl mx-auto p-8 rounded-lg fade-in"
      style={{
        background: 'rgba(255, 255, 255, 0.03)',
        border: '1px solid var(--border-subtle)'
      }}
    >
      {/* Progress Bar */}
      <div className="mb-8">
        <div className="flex justify-between items-center mb-2">
          <span className="body-medium" style={{ color: 'var(--text-primary)' }}>Step {step} of 4</span>
          <span className="body-medium" style={{ color: 'var(--brand-primary)' }}>{step * 25}% Complete</span>
        </div>
        <div
          className="w-full h-2 rounded-full"
          style={{ background: 'rgba(255, 255, 255, 0.1)' }}
        >
          <div
            className="h-2 rounded-full dark-transition"
            style={{
              background: 'var(--brand-primary)',
              width: `${step * 25}%`
            }}
          />
        </div>
      </div>

      <h3 className="display-medium mb-4" style={{ color: 'var(--text-primary)' }}>
        {step === 1 && 'Website Development'}
        {step === 2 && 'Lead Generation'}
        {step === 3 && 'AI Automation'}
        {step === 4 && 'Add-ons'}
      </h3>

      {/* Step 1: Website */}
      {step === 1 && (
        <div className="space-y-3">
          {websiteOptions.map((option, idx) => (
            <div
              key={idx}
              onClick={() => setSelectedServices({ ...selectedServices, website: option })}
              className={`p-4 rounded-lg cursor-pointer dark-transition ${
                selectedServices.website?.name === option.name ? 'ring-2' : ''
              }`}
              style={{
                background: selectedServices.website?.name === option.name
                  ? 'rgba(0, 255, 209, 0.1)'
                  : 'rgba(255, 255, 255, 0.05)',
                border: selectedServices.website?.name === option.name
                  ? '1px solid var(--brand-primary)'
                  : '1px solid var(--border-subtle)'
              }}
            >
              <div className="flex justify-between items-center">
                <div className="heading-3" style={{ color: 'var(--text-primary)' }}>{option.name}</div>
                <div className="body-medium" style={{ color: 'var(--brand-primary)' }}>
                  {typeof option.price === 'number' && option.price === 0 ? '$0' : typeof option.price === 'number' ? `$${option.price}` : option.price}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Step 2: Lead Gen */}
      {step === 2 && (
        <div className="space-y-3">
          {leadGenOptions.map((option, idx) => (
            <div
              key={idx}
              onClick={() => setSelectedServices({ ...selectedServices, leadGen: option })}
              className={`p-4 rounded-lg cursor-pointer dark-transition ${
                selectedServices.leadGen?.name === option.name ? 'ring-2' : ''
              }`}
              style={{
                background: selectedServices.leadGen?.name === option.name
                  ? 'rgba(0, 255, 209, 0.1)'
                  : 'rgba(255, 255, 255, 0.05)',
                border: selectedServices.leadGen?.name === option.name
                  ? '1px solid var(--brand-primary)'
                  : '1px solid var(--border-subtle)'
              }}
            >
              <div className="flex justify-between items-center">
                <div className="heading-3" style={{ color: 'var(--text-primary)' }}>{option.name}</div>
                <div className="body-medium" style={{ color: 'var(--brand-primary)' }}>
                  {typeof option.price === 'number' && option.price === 0 ? '$0' : option.price}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Step 3: Automation */}
      {step === 3 && (
        <div className="space-y-3">
          {automationOptions.map((option, idx) => (
            <div
              key={idx}
              onClick={() => setSelectedServices({ ...selectedServices, automation: option })}
              className={`p-4 rounded-lg cursor-pointer dark-transition ${
                selectedServices.automation?.name === option.name ? 'ring-2' : ''
              }`}
              style={{
                background: selectedServices.automation?.name === option.name
                  ? 'rgba(0, 255, 209, 0.1)'
                  : 'rgba(255, 255, 255, 0.05)',
                border: selectedServices.automation?.name === option.name
                  ? '1px solid var(--brand-primary)'
                  : '1px solid var(--border-subtle)'
              }}
            >
              <div className="flex justify-between items-center">
                <div className="heading-3" style={{ color: 'var(--text-primary)' }}>{option.name}</div>
                <div className="body-medium" style={{ color: 'var(--brand-primary)' }}>
                  {typeof option.price === 'number' && option.price === 0 ? '$0' : option.price}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Step 4: Add-ons */}
      {step === 4 && (
        <div className="space-y-3">
          {addonOptions.map((option, idx) => (
            <div
              key={idx}
              onClick={() => toggleAddon(option)}
              className={`p-4 rounded-lg cursor-pointer dark-transition ${
                selectedServices.addons.includes(option) ? 'ring-2' : ''
              }`}
              style={{
                background: selectedServices.addons.includes(option)
                  ? 'rgba(0, 255, 209, 0.1)'
                  : 'rgba(255, 255, 255, 0.05)',
                border: selectedServices.addons.includes(option)
                  ? '1px solid var(--brand-primary)'
                  : '1px solid var(--border-subtle)'
              }}
            >
              <div className="flex justify-between items-center">
                <div className="flex items-center space-x-3">
                  {selectedServices.addons.includes(option) && (
                    <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)' }} />
                  )}
                  <div className="heading-3" style={{ color: 'var(--text-primary)' }}>{option.name}</div>
                </div>
                <div className="body-medium" style={{ color: 'var(--brand-primary)' }}>
                  {option.price}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Navigation Buttons */}
      <div className="flex justify-between mt-8">
        <button
          onClick={handlePrevious}
          disabled={step === 1}
          className="button-text dark-button-animate inline-flex items-center space-x-2"
          style={{
            background: step === 1 ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.1)',
            color: step === 1 ? 'var(--text-muted)' : '#FFFFFF',
            padding: '12px 24px',
            borderRadius: '0px',
            border: 'none',
            cursor: step === 1 ? 'not-allowed' : 'pointer'
          }}
        >
          <ArrowLeft size={20} />
          <span>Previous</span>
        </button>
        <button
          onClick={handleNext}
          className="button-text dark-button-animate inline-flex items-center space-x-2"
          style={{
            background: 'var(--brand-primary)',
            color: '#000000',
            padding: '12px 24px',
            borderRadius: '0px',
            border: 'none',
            cursor: 'pointer'
          }}
        >
          <span>{step === 4 ? 'Get My Quote' : 'Next Step'}</span>
          <ArrowRight size={20} />
        </button>
      </div>
    </div>
  );
};

export default QuoteBuilder;